import { useState } from "react";
export const useSponsorDetailState = () => {
 const [sponsor, setSponsor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sponsorAds, setSponsorAds] = useState([]);
    return {
        sponsor, setSponsor, loading, setLoading, error, setError, sponsorAds, setSponsorAds
    }
}